export const fixLightboxOverlayTouchActionExperiment =
  'specs.thunderbolt.fixLightboxOverlayIosTouchAction';
